var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6752 8.69898C18.5185 8.10989 18.0549 7.64516 17.4651 7.48589C16.3988 7.20007 12.1202 7.20007 12.1202 7.20007C12.1202 7.20007 7.84388 7.20007 6.77534 7.48589C6.18775 7.64298 5.7242 8.10771 5.56533 8.69898C5.28024 9.76807 5.28024 12.0001 5.28024 12.0001C5.28024 12.0001 5.28024 14.2321 5.56533 15.3012C5.72202 15.8903 6.18557 16.355 6.77534 16.5143C7.84388 16.8001 12.1202 16.8001 12.1202 16.8001C12.1202 16.8001 16.3988 16.8001 17.4651 16.5143C18.0527 16.3572 18.5163 15.8924 18.6752 15.3012C18.9602 14.2321 18.9602 12.0001 18.9602 12.0001C18.9602 12.0001 18.9602 9.76807 18.6752 8.69898Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7535 14.0575L14.3074 12.0001L10.7535 9.94262V14.0575Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.31e57fd899e089e8062180d255182a81.svg";
export { ForwardRef as ReactComponent };